"use strict";
var Observable_1 = require('../../Observable');
var map_1 = require('../../operator/map');
Observable_1.Observable.prototype.map = map_1.map;
//# sourceMappingURL=map.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/rxjs/add/operator/map.js
 ** module id = 594
 ** module chunks = 0
 **/